import { DataModel } from "../models/DataModel";

export const fetchGuides = async (): Promise<DataModel[]> => {
  return fetch("/vejledninger.json").then((data) => data.json());
};
